module.exports = __webpack_public_path__ + "static/media/samsung-aife-2019-fastcharging.7b01c931.mp4";